<!-- Upgrade / Downgrade execution confirmation -->
<p-dialog
    header="Confirmation"
    [(visible)]="ShowCustomConfirmation"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
>
    <div *ngIf="upgradeSucessMessage.length == 0" class="plan-upgrade-message">
        <strong
            >You have chosen to
            {{ CurrentAction == 1 ? "upgrade" : "downgrade" }} your
            plan.</strong
        >
        <br /><br />
        <table class="p-datatable-table ng-star-inserted upgrade-plan">
            <tr class="ng-star-inserted">
                <td>
                    From: <strong>{{ resolvedPlanName }} plan</strong>
                </td>
                <td>
                    <strong>${{ currentSubscriptionCharges }}</strong>
                    {{
                        (planData?.subscriptionInterval === 12
                            ? "/ Year "
                            : "/ Month") + "(Subscription + Tax)"
                    }}
                </td>
            </tr>
            <tr class="ng-star-inserted">
                <td>
                    To:
                    <strong
                        >{{ _signup.selectedPlanDetails?.title }} plan</strong
                    >
                </td>
                <td>
                    <strong>${{ newSubscriptionCharges }}</strong>
                    {{
                        (planData?.subscriptionInterval === 12
                            ? "/ Year"
                            : "/ Month") + "(Subscription + Tax)"
                    }}
                </td>
            </tr>
        </table>
        <ng-container *ngIf="subscriptionChangeNotes.length > 0">
            <p-messages severity="info">
                <ng-template pTemplate>
                    <div class="ml-2">{{ subscriptionChangeNotes }}</div>
                </ng-template>
            </p-messages>
        </ng-container>
        Would you like to proceed?
    </div>
    <div *ngIf="upgradeSucessMessage.length > 0" class="plan-upgrade-message">
        <p>You have sucessfully updated your plan</p>
    </div>

    <div class="flex flex-wrap align-items-center justify-content-center m-2">
        <div class="flex align-items-center justify-content-center m-2">
            <button
                pButton
                type="button"
                label="Confirm"
                *ngIf="upgradeSucessMessage.length == 0"
                class="ml-2"
                style="width: 160px"
                (click)="performAction()"
            ></button>
            <button
                pButton
                type="button"
                label="Ok"
                class="ml-2"
                style="width: 160px"
                (click)="closeConfirmationDialog()"
                *ngIf="upgradeSucessMessage.length > 0"
            ></button>
            <button
                pButton
                type="button"
                label="Cancel"
                *ngIf="upgradeSucessMessage.length == 0"
                class="ml-2"
                style="width: 160px"
                (click)="ShowCustomConfirmation = false"
            ></button>
        </div>
    </div>

    <div style="color: red" *ngIf="ErrorMessage.length > 0">
        <br />
        <br />
        {{ ErrorMessage }}
    </div>
</p-dialog>

<div class="plans-screen">
    <button type="button" class="plans-back-btn" *ngIf="isLoggedIn" (click)="goBack()">
        <i class="pi pi-chevron-left"></i> Back to dashboard
    </button>

    <div class="plans-days-left-banner" *ngIf="trialDaysLeft !== null">
        <i class="pi pi-clock"></i>
        {{ trialDaysLeft }} day{{ trialDaysLeft === 1 ? '' : 's' }} left to pick a plan
    </div>

    <ng-container *ngIf="!isLoading; else plansSkeleton">
        <!-- TODO re-enable: monthly/yearly toggle hidden per request -->
        <div class="plans-interval-toggle" *ngIf="false">
            <button
                type="button"
                [class.active]="isMonthly"
                (click)="currentInterval(true)"
            >Pay Monthly</button>
            <button
                type="button"
                [class.active]="!isMonthly"
                (click)="currentInterval(false)"
            >Pay Yearly</button>
        </div>
        <div class="plans-cards-grid">
            <div class="plans-card" *ngFor="let card of displayPlanCards; trackBy: trackPlanCardById" [class.current]="card.isCurrent" [class.temp-selected]="card.isTempSelected">
                <div class="plans-card-temp-badge" *ngIf="card.isTempSelected"><i class="pi pi-check"></i> Selected</div>
                <div class="plans-card-title">{{ card.title }}</div>
                <div class="plans-card-price">{{ card.priceLabel }}</div>
                <div class="plans-card-per">/month{{ !card.isFree && !isMonthly ? ', billed yearly' : '' }}</div>
                <!-- TODO re-enable: plan badge hidden per request -->
                <div class="plans-card-badge" [class.free]="card.isFree" *ngIf="false">
                    <i class="pi pi-star-fill" *ngIf="!card.isFree"></i> {{ card.badge }}
                </div>
                <div class="plans-card-trial-days" *ngIf="trialDaysLeft !== null">
                    {{ trialDaysLeft }} day{{ trialDaysLeft === 1 ? '' : 's' }} left<ng-container *ngIf="!card.isCurrent"> if you switch</ng-container>
                </div>
                <button
                    type="button"
                    class="plans-card-cta"
                    [class.current]="card.isCurrent"
                    [disabled]="card.isDisabled"
                    (click)="selectPlanCard(card)"
                >{{ card.buttonLabel }}</button>
                <div class="plans-card-features" *ngIf="card.features.length">
                    <div class="plans-card-features-label">Standout Features</div>
                    <!-- TODO re-enable: excluded features hidden per request -->
                    <div
                        class="plans-card-feature"
                        *ngFor="let feat of card.features"
                        [ngClass]="{ 'included-in-plan': feat.included, 'exluded-in-plan': !feat.included }"
                        [hidden]="!feat.included"
                    >
                        <i class="{{ feat.icon }}"></i> {{ feat.title }}
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-template #plansSkeleton>
        <div class="plans-cards-grid">
            <div class="plans-card" *ngFor="let row of [1,2]">
                <p-skeleton width="60%" height="1.5rem" styleClass="mb-3"></p-skeleton>
                <p-skeleton width="40%" height="2.5rem" styleClass="mb-3"></p-skeleton>
                <p-skeleton width="80%" height="1rem" styleClass="mb-3"></p-skeleton>
                <p-skeleton width="100%" height="3rem"></p-skeleton>
            </div>
        </div>
    </ng-template>
</div>

<!-- Leave-with-cart confirm — "Back to dashboard" when a checkout was already started here -->
<p-dialog
    header="Go to dashboard?"
    [(visible)]="showLeaveWithCartConfirm"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closable]="false"
    [style]="{ width: '440px', maxWidth: '92vw' }"
>
    <p>You have items in your cart from checkout. Leaving now will clear them.</p>
    <ng-template pTemplate="footer">
        <button pButton type="button" label="Stay here" class="p-button-outlined" (click)="confirmLeaveWithCart(false)"></button>
        <button pButton type="button" label="Go to dashboard" (click)="confirmLeaveWithCart(true)"></button>
    </ng-template>
</p-dialog>
